<script lang="ts">
	import { Text } from '@Shelly/shelly-design-system';
	import DashCameraCardInfoLine from './DashCameraCardInfoLine.svelte';
	import type { Device } from 'src/types/Device';
	import type { DeviceSettingsG2 } from 'src/types/DeviceSettings';
	import type { DeviceStatusG2 } from 'src/types/DeviceStatusG2';

	export let device: Device | undefined;
	export let status: DeviceStatusG2 | undefined;
	export let settings: DeviceSettingsG2 | undefined;
	export let showLiveBadge = false;
	export let compact = false;
	export let denseOverlay = false;
	export let useCloudConnectionIcon = false;
	export let showDeviceName = false;
</script>

<div class="dash-camera-widget-header" class:compact class:dense-overlay={denseOverlay}>
	{#if device}
		<DashCameraCardInfoLine
			{device}
			{status}
			{settings}
			{showLiveBadge}
			compact={compact || denseOverlay}
			{denseOverlay}
			{useCloudConnectionIcon}
			alignEnd
			onDark
		/>
	{/if}
	{#if showDeviceName && device?.name}
		<Text
			styleType={compact ? 'body-extra-small' : 'body-small'}
			class="device-name text-white"
			noWrap
		>
			{device.name}
		</Text>
	{/if}
</div>

<style>
	.dash-camera-widget-header {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: var(--spacing-xs);
		width: auto;
		max-width: 100%;
		pointer-events: none;
		box-sizing: border-box;
	}

	.device-name {
		opacity: 0.9;
	}
</style>
